import React, { useCallback, useEffect, useRef, useState } from "react";

// ============ ICONS ============
export const Ic = {
  Home: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" /><path d="M9 22V12h6v10" /></svg>,
  Users: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 00-3-3.87" /><path d="M16 3.13a4 4 0 010 7.75" /></svg>,
  Zap: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 12h-4l-3 9L9 3l-3 9H2" /></svg>,
  Repeat: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="17 1 21 5 17 9" /><path d="M3 11V9a4 4 0 014-4h14" /><polyline points="7 23 3 19 7 15" /><path d="M21 13v2a4 4 0 01-4 4H3" /></svg>,
  Grid: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7" /><rect x="14" y="3" width="7" height="7" /><rect x="14" y="14" width="7" height="7" /><rect x="3" y="14" width="7" height="7" /></svg>,
  Gift: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="8" width="18" height="13" rx="2" /><path d="M12 8v13" /><path d="M19 8a2.5 2.5 0 0 0 0-5c-3 0-4.5 3-7 5 2.5 0 4 .5 7 0Z" /><path d="M5 8a2.5 2.5 0 0 1 0-5c3 0 4.5 3 7 5-2.5 0-4 .5-7 0Z" /></svg>,
  Chart: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="20" x2="18" y2="10" /><line x1="12" y1="20" x2="12" y2="4" /><line x1="6" y1="20" x2="6" y2="14" /></svg>,
  User: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" /><circle cx="12" cy="7" r="4" /></svg>,
  Settings: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3" /><path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-2 2 2 2 0 01-2-2v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83 0 2 2 0 010-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 01-2-2 2 2 0 012-2h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 010-2.83 2 2 0 012.83 0l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 012-2 2 2 0 012 2v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 0 2 2 0 010 2.83l-.06.06a1.65 1.65 0 00-.33 1.82V9a1.65 1.65 0 001.51 1H21a2 2 0 012 2 2 2 0 01-2 2h-.09a1.65 1.65 0 00-1.51 1z" /></svg>,
  Plus: () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><path d="M12 5v14M5 12h14" /></svg>,
  X: () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M18 6L6 18M6 6l12 12" /></svg>,
  Check: () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><path d="M20 6L9 17l-5-5" /></svg>,
  Edit: () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" /><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" /></svg>,
  Eye: () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /><circle cx="12" cy="12" r="3" /></svg>,
  Trash: () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6" /><path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2" /></svg>,
  Search: () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" /></svg>,
  Back: () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M19 12H5M12 19l-7-7 7-7" /></svg>,
  Clock: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></svg>,
  Heart: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="white" stroke="white" strokeWidth="2"><path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z" /></svg>,
  TrendUp: () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18" /><polyline points="17 6 23 6 23 12" /></svg>,
  LogOut: () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4" /><polyline points="16 17 21 12 16 7" /><line x1="21" y1="12" x2="9" y2="12" /></svg>,
  Phone: () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6A19.79 19.79 0 012.12 4.11 2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" /></svg>,
  Mail: () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" /><polyline points="22,6 12,13 2,6" /></svg>,
  Calendar: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" /></svg>,
  Note: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><polyline points="14 2 14 8 20 8" /><line x1="16" y1="13" x2="8" y2="13" /><line x1="16" y1="17" x2="8" y2="17" /><polyline points="10 9 9 9 8 9" /></svg>,
  Loader: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" style={{ animation: "spin 1s linear infinite" }}><path d="M21 12a9 9 0 11-6.219-8.56" /></svg>,
  Copy: () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2" /><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" /></svg>,
};

// ============ DOMAIN TAG ============
export function DomainTag({ domain }) {
  if (!domain) return null;
  return (
    <span style={{ display: "inline-flex", alignItems: "center", padding: "3px 10px", borderRadius: 6, fontSize: 12, fontWeight: 500, margin: 2, gap: 4, background: domain.color + "18", color: domain.color }}>
      <span style={{ width: 7, height: 7, borderRadius: "50%", background: domain.color, flexShrink: 0 }} />
      {domain.name}
    </span>
  );
}

// ============ STATUS BADGE ============
export function StatusBadge({ status }) {
  const isActive = status === "active";
  return (
    <span style={{ display: "inline-flex", alignItems: "center", padding: "3px 10px", borderRadius: 20, fontSize: 12, fontWeight: 500, gap: 4, background: isActive ? "#F0FDF4" : "#F5F5F5", color: isActive ? "#16A34A" : "#737373" }}>
      <span style={{ width: 6, height: 6, borderRadius: "50%", background: isActive ? "#16A34A" : "#A3A3A3" }} />
      {isActive ? "פעיל" : "לא פעיל"}
    </span>
  );
}

// ============ MODAL ============
export function Modal({ title, onClose, children, footer }) {
  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)", backdropFilter: "blur(4px)", zIndex: 100, display: "flex", alignItems: "center", justifyContent: "center" }} onClick={onClose}>
      <div style={{ background: "white", borderRadius: 18, width: 520, maxWidth: "90vw", maxHeight: "85vh", overflowY: "auto", boxShadow: "0 20px 60px rgba(0,0,0,0.15)" }} onClick={(e) => e.stopPropagation()}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "20px 24px", borderBottom: "1px solid #E8E8E8" }}>
          <h3 style={{ fontFamily: "Assistant", fontSize: 18, fontWeight: 700 }}>{title}</h3>
          <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", padding: 8, borderRadius: 8 }}><Ic.X /></button>
        </div>
        <div style={{ padding: 24 }}>{children}</div>
        {footer && <div style={{ display: "flex", gap: 10, padding: "16px 24px", borderTop: "1px solid #E8E8E8" }}>{footer}</div>}
      </div>
    </div>
  );
}

function normalizeSearchValue(value) {
  return `${value || ""}`
    .trim()
    .toLowerCase()
    .replace(/['"׳״]/g, "")
    .replace(/\s+/g, " ");
}

export function SearchableSelect({
  value,
  onChange,
  options = [],
  placeholder = "בחר",
  searchPlaceholder = "חיפוש...",
  emptyText = "לא נמצאו תוצאות",
  disabled = false,
  getOptionValue = (option) => option?.value ?? option?.id ?? "",
  getOptionLabel = (option) => option?.label ?? option?.name ?? "",
  getOptionKeywords = () => "",
}) {
  const rootRef = useRef(null);
  const selectedOption = options.find((option) => `${getOptionValue(option)}` === `${value || ""}`) || null;
  const [query, setQuery] = useState(selectedOption ? getOptionLabel(selectedOption) : "");
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setQuery(selectedOption ? getOptionLabel(selectedOption) : "");
  }, [selectedOption, getOptionLabel]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!rootRef.current || rootRef.current.contains(event.target)) return;
      setOpen(false);
      setQuery(selectedOption ? getOptionLabel(selectedOption) : "");
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [selectedOption, getOptionLabel]);

  const filteredOptions = options.filter((option) => {
    const needle = normalizeSearchValue(query);
    if (!needle) return true;
    const haystack = normalizeSearchValue([
      getOptionLabel(option),
      getOptionKeywords(option),
    ].filter(Boolean).join(" "));
    return haystack.includes(needle);
  });

  const commitSelection = (option) => {
    const nextValue = option ? getOptionValue(option) : "";
    setQuery(option ? getOptionLabel(option) : "");
    setOpen(false);
    onChange(nextValue, option || null);
  };

  return (
    <div ref={rootRef} style={{ position: "relative" }}>
      <div style={{ position: "relative" }}>
        <input
          style={{ ...inputStyle, paddingLeft: 40 }}
          value={query}
          placeholder={placeholder}
          autoComplete="off"
          disabled={disabled}
          onFocus={() => !disabled && setOpen(true)}
          onChange={(e) => {
            setQuery(e.target.value);
            setOpen(true);
          }}
          onKeyDown={(e) => {
            if (e.key === "Escape") {
              setOpen(false);
              setQuery(selectedOption ? getOptionLabel(selectedOption) : "");
            }
            if (e.key === "Enter" && filteredOptions.length === 1) {
              e.preventDefault();
              commitSelection(filteredOptions[0]);
            }
          }}
        />
        <span style={{ position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)", color: "#A3A3A3", pointerEvents: "none" }}>
          <Ic.Search />
        </span>
      </div>
      {open && !disabled && (
        <div style={{
          position: "absolute",
          top: "calc(100% + 6px)",
          right: 0,
          left: 0,
          zIndex: 40,
          background: "#fff",
          border: "1px solid #E5E7EB",
          borderRadius: 12,
          boxShadow: "0 12px 32px rgba(15,23,42,.12)",
          overflow: "hidden",
        }}>
          <div style={{ padding: "8px 12px", borderBottom: "1px solid #F3F4F6", fontSize: 12, color: "#6B7280" }}>
            {searchPlaceholder}
          </div>
          <div style={{ maxHeight: 220, overflowY: "auto" }}>
            <button
              type="button"
              onClick={() => commitSelection(null)}
              style={{
                width: "100%",
                border: "none",
                background: "transparent",
                textAlign: "right",
                padding: "10px 12px",
                cursor: "pointer",
                fontFamily: "inherit",
                fontSize: 14,
                color: "#6B7280",
              }}
            >
              {placeholder}
            </button>
            {filteredOptions.map((option) => {
              const optionValue = `${getOptionValue(option)}`;
              const selected = optionValue === `${value || ""}`;
              return (
                <button
                  key={optionValue}
                  type="button"
                  onClick={() => commitSelection(option)}
                  style={{
                    width: "100%",
                    border: "none",
                    background: selected ? "#FFF1F3" : "transparent",
                    textAlign: "right",
                    padding: "10px 12px",
                    cursor: "pointer",
                    fontFamily: "inherit",
                    fontSize: 14,
                    color: selected ? "#C41E3A" : "#111827",
                  }}
                >
                  {getOptionLabel(option)}
                </button>
              );
            })}
            {filteredOptions.length === 0 && (
              <div style={{ padding: "12px", fontSize: 13, color: "#9CA3AF", textAlign: "center" }}>
                {emptyText}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export function AutocompleteTextInput({
  value,
  onChange,
  options = [],
  placeholder = "",
  emptyText = "אין התאמות",
  disabled = false,
}) {
  const rootRef = useRef(null);
  const [open, setOpen] = useState(false);
  const filteredOptions = options.filter((option, index, arr) => {
    const normalizedOption = normalizeSearchValue(option);
    if (!normalizedOption) return false;
    const firstIndex = arr.findIndex((item) => normalizeSearchValue(item) === normalizedOption);
    if (firstIndex !== index) return false;
    const query = normalizeSearchValue(value);
    return !query || normalizedOption.includes(query);
  });

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!rootRef.current || rootRef.current.contains(event.target)) return;
      setOpen(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div ref={rootRef} style={{ position: "relative" }}>
      <div style={{ position: "relative" }}>
        <input
          style={{ ...inputStyle, paddingLeft: 40 }}
          value={value || ""}
          placeholder={placeholder}
          disabled={disabled}
          onFocus={() => !disabled && setOpen(true)}
          onChange={(e) => {
            onChange(e.target.value);
            setOpen(true);
          }}
          onKeyDown={(e) => {
            if (e.key === "Escape") setOpen(false);
          }}
        />
        <span style={{ position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)", color: "#A3A3A3", pointerEvents: "none" }}>
          <Ic.Search />
        </span>
      </div>
      {open && !disabled && (
        <div style={{
          position: "absolute",
          top: "calc(100% + 6px)",
          right: 0,
          left: 0,
          zIndex: 40,
          background: "#fff",
          border: "1px solid #E5E7EB",
          borderRadius: 12,
          boxShadow: "0 12px 32px rgba(15,23,42,.12)",
          overflow: "hidden",
        }}>
          <div style={{ maxHeight: 220, overflowY: "auto" }}>
            {filteredOptions.map((option) => (
              <button
                key={option}
                type="button"
                onClick={() => {
                  onChange(option);
                  setOpen(false);
                }}
                style={{
                  width: "100%",
                  border: "none",
                  background: normalizeSearchValue(option) === normalizeSearchValue(value) ? "#FFF1F3" : "transparent",
                  textAlign: "right",
                  padding: "10px 12px",
                  cursor: "pointer",
                  fontFamily: "inherit",
                  fontSize: 14,
                }}
              >
                {option}
              </button>
            ))}
            {filteredOptions.length === 0 && (
              <div style={{ padding: "12px", fontSize: 13, color: "#9CA3AF", textAlign: "center" }}>
                {emptyText}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

// ============ TOAST ============
export function useToast() {
  const [msg, setMsg] = useState(null);
  const timerRef = useRef(null);

  useEffect(() => () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
  }, []);

  const show = useCallback((text) => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    setMsg(text);
    timerRef.current = setTimeout(() => setMsg(null), 2500);
  }, []);

  const ToastEl = msg ? (
    <div style={{ position: "fixed", bottom: 24, left: "50%", transform: "translateX(-50%)", background: "#171717", color: "white", padding: "12px 24px", borderRadius: 12, fontSize: 14, zIndex: 200, boxShadow: "0 8px 32px rgba(0,0,0,0.2)", display: "flex", alignItems: "center", gap: 8 }}>
      <Ic.Check />{msg}
    </div>
  ) : null;
  return { show, ToastEl };
}

// ============ LOADING ============
export function LoadingSpinner() {
  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: 48, color: "#A3A3A3" }}>
      <Ic.Loader />
      <span style={{ marginRight: 8, fontSize: 14 }}>טוען...</span>
    </div>
  );
}

// ============ STYLES ============
export const inputStyle = { width: "100%", padding: "10px 14px", border: "1.5px solid #E8E8E8", borderRadius: 10, fontSize: 14, direction: "rtl", background: "white", outline: "none", color: "#262626", fontFamily: "Heebo, sans-serif" };
export const btnPrimary = { display: "inline-flex", alignItems: "center", gap: 8, padding: "9px 18px", borderRadius: 10, fontSize: 14, fontWeight: 500, cursor: "pointer", border: "none", background: "#C41E3A", color: "white", boxShadow: "0 2px 8px rgba(196,30,58,0.25)", fontFamily: "Heebo, sans-serif" };
export const btnSecondary = { display: "inline-flex", alignItems: "center", gap: 8, padding: "9px 18px", borderRadius: 10, fontSize: 14, fontWeight: 500, cursor: "pointer", border: "1px solid #E8E8E8", background: "#F5F5F5", color: "#404040", fontFamily: "Heebo, sans-serif" };
export const btnGhost = { background: "none", border: "none", cursor: "pointer", padding: 8, borderRadius: 8, display: "inline-flex", alignItems: "center" };
export const btnDanger = { ...btnPrimary, background: "#DC2626", boxShadow: "0 2px 8px rgba(220,38,38,0.25)" };

export const DAYS_HEB = ["ראשון", "שני", "שלישי", "רביעי", "חמישי", "שישי", "שבת"];
export const DOMAIN_COLORS = [
  "#C41E3A", "#BE123C", "#DB2777", "#E11D48", "#F43F5E",
  "#2563EB", "#1D4ED8", "#3B82F6", "#0EA5E9", "#0891B2",
  "#16A34A", "#22C55E", "#15803D", "#65A30D", "#84CC16",
  "#EA580C", "#F97316", "#FB923C", "#D97706", "#F59E0B",
  "#7C3AED", "#8B5CF6", "#A855F7", "#6366F1", "#4F46E5",
  "#92400E", "#A16207", "#374151", "#0F172A", "#475569",
];

export function fmtDate(d) {
  if (!d) return "";
  const date = typeof d === "string" ? new Date(d) : d;
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
}

function buildDialogShell({ title, message, confirmText = "אישור", cancelText = "" }) {
  const overlay = document.createElement("div");
  Object.assign(overlay.style, {
    position: "fixed",
    inset: "0",
    background: "rgba(0,0,0,0.45)",
    backdropFilter: "blur(4px)",
    zIndex: "9999",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    direction: "rtl",
  });

  const box = document.createElement("div");
  Object.assign(box.style, {
    width: "min(92vw, 420px)",
    background: "#fff",
    borderRadius: "16px",
    border: "1px solid #E8E8E8",
    boxShadow: "0 20px 60px rgba(0,0,0,0.2)",
    overflow: "hidden",
    fontFamily: "Heebo, sans-serif",
  });

  const head = document.createElement("div");
  Object.assign(head.style, {
    padding: "16px 18px",
    borderBottom: "1px solid #E8E8E8",
    fontFamily: "Assistant, sans-serif",
    fontSize: "20px",
    fontWeight: "800",
    color: "#171717",
  });
  head.textContent = title;

  const body = document.createElement("div");
  Object.assign(body.style, {
    padding: "16px 18px",
    fontSize: "14px",
    color: "#404040",
    lineHeight: "1.6",
    whiteSpace: "pre-wrap",
  });
  body.textContent = message || "";

  const footer = document.createElement("div");
  Object.assign(footer.style, {
    padding: "12px 16px",
    borderTop: "1px solid #E8E8E8",
    display: "flex",
    gap: "8px",
    justifyContent: "flex-end",
  });

  const confirmBtn = document.createElement("button");
  Object.assign(confirmBtn.style, {
    border: "none",
    borderRadius: "10px",
    background: "#C41E3A",
    color: "white",
    padding: "8px 14px",
    cursor: "pointer",
    fontFamily: "Heebo, sans-serif",
    fontSize: "14px",
    fontWeight: "600",
  });
  confirmBtn.textContent = confirmText;

  footer.appendChild(confirmBtn);
  let cancelBtn = null;
  if (cancelText) {
    cancelBtn = document.createElement("button");
    Object.assign(cancelBtn.style, {
      border: "1px solid #E8E8E8",
      borderRadius: "10px",
      background: "#F5F5F5",
      color: "#404040",
      padding: "8px 14px",
      cursor: "pointer",
      fontFamily: "Heebo, sans-serif",
      fontSize: "14px",
      fontWeight: "600",
    });
    cancelBtn.textContent = cancelText;
    footer.appendChild(cancelBtn);
  }

  box.appendChild(head);
  box.appendChild(body);
  box.appendChild(footer);
  overlay.appendChild(box);
  return { overlay, confirmBtn, cancelBtn };
}

export function showStyledAlert(message, title = "התראה") {
  return new Promise((resolve) => {
    const { overlay, confirmBtn } = buildDialogShell({
      title,
      message,
      confirmText: "סגור",
    });
    const close = () => {
      overlay.remove();
      resolve();
    };
    confirmBtn.addEventListener("click", close);
    overlay.addEventListener("click", (e) => {
      if (e.target === overlay) close();
    });
    document.body.appendChild(overlay);
  });
}

export function showStyledConfirm(message, title = "אישור פעולה") {
  return new Promise((resolve) => {
    const { overlay, confirmBtn, cancelBtn } = buildDialogShell({
      title,
      message,
      confirmText: "אישור",
      cancelText: "ביטול",
    });
    const close = (result) => {
      overlay.remove();
      resolve(result);
    };
    confirmBtn.addEventListener("click", () => close(true));
    if (cancelBtn) cancelBtn.addEventListener("click", () => close(false));
    overlay.addEventListener("click", (e) => {
      if (e.target === overlay) close(false);
    });
    document.body.appendChild(overlay);
  });
}
